import React, { useEffect, useRef, useState } from "react";

/**
 * Custom cursor follower (desktop only, respects prefers-reduced-motion)
 */
const CursorFollower = () => {
  const dotRef = useRef(null);
  const [enabled, setEnabled] = useState(false);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia("(hover: hover) and (pointer: fine)");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!mq.matches || reduced.matches) return;
    setEnabled(true);
    document.body.classList.add("has-cursor");

    let raf = 0;
    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let tx = x;
    let ty = y;

    const onMove = (e) => {
      tx = e.clientX;
      ty = e.clientY;
    };

    const onOver = (e) => {
      const target = e.target;
      if (
        target.closest(
          "a, button, [role='button'], input, textarea, select, [data-hover='true']"
        )
      ) {
        setHover(true);
      } else {
        setHover(false);
      }
    };

    const tick = () => {
      x += (tx - x) * 0.22;
      y += (ty - y) * 0.22;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(tick);
    };

    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseover", onOver);
    raf = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseover", onOver);
      cancelAnimationFrame(raf);
      document.body.classList.remove("has-cursor");
    };
  }, []);

  if (!enabled) return null;

  return (
    <div
      ref={dotRef}
      aria-hidden="true"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: hover ? 36 : 10,
        height: hover ? 36 : 10,
        background: hover ? "transparent" : "#E0DC1B",
        border: hover ? "1.5px solid #E0DC1B" : "none",
        borderRadius: "9999px",
        pointerEvents: "none",
        zIndex: 9998,
        mixBlendMode: "difference",
        transition: "width 180ms ease, height 180ms ease, background 180ms ease, border 180ms ease",
      }}
      data-testid="cursor-follower"
    />
  );
};

export default CursorFollower;
